export default __webpack_public_path__ + "static/media/bg_metal_tekening.3c529841.png";